import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spin } from 'antd';

import NotificationSettings from '../../../components/redesign/pages/NotificationSettings';

/**
 * Notification preferences, reusing the standalone settings page's control set.
 *
 * Presentational. The container owns the PATCH and the hard guard that refuses
 * to save an unloaded profile.
 */
const NotificationsStep = ({
  settings, loaded, loadFailed, saving, onRetry, onChange,
}) => {
  // Never render the toggles from an empty settings object: every switch would
  // read as off and the user would believe they had reviewed their preferences.
  if (!loaded) {
    return (
      <div className="walkthrough-compact-step">
        <h2>Notifications</h2>
        {loadFailed ? (
          <>
            <p className="walkthrough-inline-error">
              We could not load your notification settings.
            </p>
            <Button type="primary" onClick={onRetry}>Retry</Button>
          </>
        ) : (
          <>
            <Spin />
            <p>Loading your notification settings...</p>
          </>
        )}
      </div>
    );
  }

  return (
    <div className="walkthrough-notifications-step">
      <NotificationSettings
        loading={saving}
        notificationFaxEmail={settings.notification_fax_email}
        emailNotificationEmailedRecords={settings.email_notification_emailed_records}
        emailNotificationAssignedRecords={settings.email_notification_assigned_records}
        emailNotificationEmrUploadFailures={settings.email_notification_emr_upload_failures}
        failedSentFaxesNotification={settings.failed_sent_faxes_notification}
        onRecordsReceived={(event) => onChange('notification_fax_email', event)}
        onRecordsEmailed={(event) => onChange('email_notification_emailed_records', event)}
        onAssigned={(event) => onChange('email_notification_assigned_records', event)}
        onEmrUploadFailures={(event) => onChange('email_notification_emr_upload_failures', event)}
        onFailedFaxes={(event) => onChange('failed_sent_faxes_notification', event)}
      />
    </div>
  );
};

NotificationsStep.defaultProps = {
  settings: {},
  loaded: false,
  loadFailed: false,
  saving: false,
};

NotificationsStep.propTypes = {
  settings: PropTypes.object,
  loaded: PropTypes.bool,
  loadFailed: PropTypes.bool,
  saving: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NotificationsStep;
